import styled from 'styled-components';
import { Button } from 'components/common';
import buttonDefaultStyle from 'components/mixins/normalize';
import media from 'components/mixins/media';
import { secondaryFontH1, secondaryFontSmallText } from 'components/mixins/typography';
import { transparentize } from 'utils/color';

export const TimedOutWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
`;

export const TitleElement = styled.h1`
  ${secondaryFontH1}
  font-weight: normal;
  line-height: 44px;
  text-align: center;
  margin-top: 55px;
  margin-bottom: 28px;
`;

export const DescriptionWrapper = styled.p`
  ${secondaryFontSmallText}
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  margin-bottom: 40px;
  font-weight: normal;
  ${media.xlarge`
    font-size: 14px;
    line-height: 22px;
  `};
`;

export const ButtonElement = styled(Button)`
  ${buttonDefaultStyle};
  flex: 0 0 auto;
  width: 227px;
  background-color: ${props => props.theme.colors.mainColor};
  font-size: 14px;
  margin-bottom: 24px;
  &:hover {
    background-color: ${props => transparentize(props.theme.colors.mainColor, 0.9)};
  }
  &:focus {
    outline: 1px solid black;
    background-color: ${props => transparentize(props.theme.colors.mainColor, 0.9)};
  }

  &.js-focus-visible :focus:not(.focus-visible) {
    outline: none;
  }
`;
